import React from "react";
import { InputNumber, Slider } from "antd";
import { SliderMarks } from "antd/es/slider";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import styled from "styled-components";

import variableColors from "../../_App.module.scss";

const SliderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-content: center;
  align-content: center;
  gap: 1rem;
  button {
    margin-top: auto !important;
    margin-bottom: auto !important;
    min-width: 4.5rem;
    height: 100% !important;
  }
  div.slider-input {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    gap: 1rem;
  }
`;

const { secondaryColor } = variableColors;

const SettingsSetCircleRadius = ({
  circleRadiusSettings,
  setCircleRadiusSettings,
  circleRadius,
  setShouldReloadWindow,
}: {
  circleRadiusSettings: number;
  setCircleRadiusSettings: React.Dispatch<React.SetStateAction<number>>;
  circleRadius: number;
  setShouldReloadWindow: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const { t } = useTranslation();

  const MIN: number = 1;
  const MAX: number = 25;
  const STEP: number = 0.5;

  const formatter = (value: number | undefined) => `${value} [km]`;

  const marks: SliderMarks = {
    1: "1km",
    5: "5km",
    12.5: {
      style: {
        color: secondaryColor,
      },
      label: `${t("Promień koła wyboru autobusu")} /12.5km/`,
    },
    20: "20km",
    25: "25km",
  };

  const resetCircleRadius = (): void => {
    setCircleRadiusSettings((circleRadius * 10) / 1000);
    setShouldReloadWindow(true);
  };

  const onInputChange = (value: number | null) => {
    if (!value) return;
    if (isNaN(value)) {
      return;
    }
    if (value >= MIN && value <= MAX) {
      const clamped: number = Math.min(MAX, Math.max(MIN, value));
      const finalValue: number = Math.round(clamped / STEP) * STEP;
      setCircleRadiusSettings(finalValue);
    } else resetCircleRadius();

    setShouldReloadWindow(true);
  };

  return (
    <React.Fragment>
      <SliderWrapper>
        <div className="slider-input">
          <Slider
            marks={marks}
            min={MIN}
            max={MAX}
            step={STEP}
            onChange={onInputChange}
            value={circleRadiusSettings}
            style={{ width: "calc(100% - 5rem)", minWidth: "5rem" }}
            tooltip={{ formatter, open: undefined, placement: "top" }}
          />

          <InputNumber
            min={MIN}
            max={MAX}
            step={STEP}
            style={{ width: "4.5rem" }}
            value={circleRadiusSettings}
            onChange={onInputChange}
          />
        </div>

        <Button
          size={undefined}
          onClick={resetCircleRadius}
          disabled={circleRadiusSettings === (circleRadius * 10) / 1000 ? true : false}
        >
          {t("Reset")}
        </Button>
      </SliderWrapper>
    </React.Fragment>
  );
};

export default SettingsSetCircleRadius;
